// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Liff from "../liff/Liff.bs.js";
import * as Title from "../components/Title.bs.js";
import * as React from "react";
import * as Layout from "../Layout.bs.js";
import * as Loading from "../components/Loading.bs.js";
import * as Promotion from "../components/Promotion.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_array from "rescript/lib/es6/caml_array.js";
import * as HookProfile from "../hooks/HookProfile.bs.js";
import * as ProfileCoupons from "./ProfileCoupons.bs.js";
import * as ProfileReducer from "./ProfileReducer.bs.js";

function ProfileCouponPage$Component(Props) {
  var coupons = Props.coupons;
  var items = Belt_Array.map(coupons, (function (coupon) {
          return coupon.code;
        }));
  var startsWith = function (target, substring) {
    return new RegExp("^" + substring).test(target);
  };
  var check_code = startsWith(Caml_array.get(items, 0), "ROZA");
  var expire = check_code ? "31/12/2564" : "31/07/2565";
  return React.createElement(Layout.Default.make, {
              children: React.createElement("div", {
                    className: "flex flex-col items-center space-y-2 w-full pt-4"
                  }, React.createElement("div", {
                        className: "flex flex-col items-center"
                      }, React.createElement(Title.make, {
                            text: "โค้ดส่วนลดของฉัน",
                            ext_class: "justify-center underline"
                          })), React.createElement("div", {
                        className: "flex flex-col w-full items-center"
                      }, React.createElement("div", {
                            className: "text-xl whitespace-pre-line text-center pb-4"
                          }, "Code ส่วนลด 10%\n            ลดสูงสุด 300 บาท (ไม่มีขั้นต่ำ)"), React.createElement(ProfileCoupons.make, {
                            coupons: coupons
                          })), React.createElement(Promotion.TextExpire.make, {
                        className: "pt-1",
                        expire: expire
                      })),
              hero: true
            });
}

var Component = {
  make: ProfileCouponPage$Component
};

function ProfileCouponPage(Props) {
  var liff = React.useContext(Liff.context);
  var state = HookProfile.useProfile(liff.access_token);
  if (typeof state === "number") {
    if (state === /* Request */0) {
      return React.createElement(Layout.Default.make, {
                  children: React.createElement("div", {
                        className: ""
                      }, React.createElement(Loading.make, {}))
                });
    } else {
      return React.createElement(Layout.$$Error.make, {});
    }
  }
  if (state.TAG !== /* SuccessRegisterdProfile */1) {
    return React.createElement(Layout.$$Error.make, {});
  }
  var coupons = ProfileReducer.getCoupons(state._0);
  return React.createElement(ProfileCouponPage$Component, {
              coupons: coupons
            });
}

var make = ProfileCouponPage;

export {
  Component ,
  make ,
  
}
/* Liff Not a pure module */
